import {
  GET_VENDOR_PROFILE,
  GET_VENDOR_PROFILE_FAIL,
  GET_VENDOR_PROFILE_SUCCESS,
  GET_VENDORS,
  GET_VENDORS_FAIL,
  GET_VENDORS_SUCCESS,
  ADD_NEW_VENDOR,
  ADD_VENDOR_SUCCESS,
  ADD_VENDOR_FAIL,
  UPDATE_VENDOR,
  UPDATE_VENDOR_SUCCESS,
  UPDATE_VENDOR_FAIL,
  DELETE_VENDOR,
  DELETE_VENDOR_SUCCESS,
  DELETE_VENDOR_FAIL,
  SET_PAGE,
  SET_OFFSET,
  SET_QUERY,
} from "./actionTypes"

export const getVendors = ({
  offset = "",
  page_size = "",
  query = "",
  status,
}) => ({
  type: GET_VENDORS,
  payload: { offset, page_size, query, status },
})

export const getVendorsSuccess = vendors => ({
  type: GET_VENDORS_SUCCESS,
  payload: vendors,
})

export const getVendorsFail = error => ({
  type: GET_VENDORS_FAIL,
  payload: error,
})

export const addNewVendor = (user, history) => ({
  type: ADD_NEW_VENDOR,
  payload: { user, history },
})

export const addVendorSuccess = user => ({
  type: ADD_VENDOR_SUCCESS,
  payload: user,
})

export const addVendorFail = error => ({
  type: ADD_VENDOR_FAIL,
  payload: error,
})

export const updateVendor = (vendor, history) => ({
  type: UPDATE_VENDOR,
  payload: { vendor, history },
})

export const updateVendorSuccess = user => ({
  type: UPDATE_VENDOR_SUCCESS,
  payload: user,
})

export const updateVendorFail = error => ({
  type: UPDATE_VENDOR_FAIL,
  payload: error,
})

export const deleteVendor = user => ({
  type: DELETE_VENDOR,
  payload: user,
})

export const deleteVendorSuccess = user => ({
  type: DELETE_VENDOR_SUCCESS,
  payload: user,
})

export const deleteVendorFail = error => ({
  type: DELETE_VENDOR_FAIL,
  payload: error,
})

export const getVendorProfile = payload => ({
  type: GET_VENDOR_PROFILE,
  payload: payload,
})

export const getVendorProfileSuccess = userProfile => ({
  type: GET_VENDOR_PROFILE_SUCCESS,
  payload: userProfile,
})

export const getVendorProfileFail = error => ({
  type: GET_VENDOR_PROFILE_FAIL,
  payload: error,
})

export const _setPage = data => ({
  type: SET_PAGE,
  payload: data,
})
export const _setOffset = data => ({
  type: SET_OFFSET,
  payload: data,
})
export const _setQuery = data => ({
  type: SET_QUERY,
  payload: data,
})
